export default __webpack_public_path__ + "assets/space_show.d275b660.png";